"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gettext_js_1 = __importDefault(require("gettext.js"));
function ctor(i18n) {
    return {
        gettext: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return i18n.gettext.apply(i18n, __spread(args));
        },
        setLocale: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return i18n.setLocale.apply(i18n, __spread(args));
        },
        setMessages: function (domain, locale, messages, pluralForm) {
            Object.keys(messages).forEach(function (msgid) {
                var msg = messages[msgid];
                if (Array.isArray(msg)) {
                    msg = msg.filter(function (m) { return m; });
                    if (msg.length === 1)
                        msg = msg[0];
                    messages[msgid] = msg;
                }
            });
            return i18n.setMessages(domain, locale, messages, pluralForm);
        },
    };
}
exports.ctor = ctor;
var _a = ctor(gettext_js_1.default()), gettext = _a.gettext, setLocale = _a.setLocale, setMessages = _a.setMessages;
exports.gettext = gettext;
exports.setLocale = setLocale;
exports.setMessages = setMessages;
//# sourceMappingURL=gettext.js.map